var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.905,
    height: 29.794,
    viewBox: "0 0 33.905 29.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clas{fill:\"current\";}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls",
    d: "M16.681,8.876,26.5,17.263a2.041,2.041,0,0,1,.457.552,1.417,1.417,0,0,1,.129.627v9.811a.92.92,0,0,1-.9.936l-6.324-.017a.92.92,0,0,1-.9-.936v-6.5a.92.92,0,0,0-.9-.936H14.446a.92.92,0,0,0-.9.936v6.5a.954.954,0,0,1-.263.664.887.887,0,0,1-.639.275l-6.321.018a.92.92,0,0,1-.9-.936V18.605a2.745,2.745,0,0,1,.222-.79,2.707,2.707,0,0,1,.482-.659l9.7-8.28A.669.669,0,0,1,16.681,8.876ZM.246,14.018,4.964,9.985V1.879A2.467,2.467,0,0,1,7.18.5a2.565,2.565,0,0,1,2.3,1.382v4.25l5.052-4.311a2.634,2.634,0,0,1,3.442,0l14.284,12.2a1.612,1.612,0,0,1,0,2.1,2.462,2.462,0,0,1-1.807.957.661.661,0,0,1-.5-.158L16.681,5.578a.669.669,0,0,0-.863,0L2.543,16.917a3,3,0,0,1-2.3-.649A3.182,3.182,0,0,1,0,14.493a.71.71,0,0,1,.247-.475Z",
    transform: "translate(0.581 0.054)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.8ee0da0b.svg";
export { ForwardRef as ReactComponent };